import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CartService } from 'src/app/services/cart.service';
import { DataService } from 'src/app/services/data.service';

declare var $: any;

@Component({
  selector: 'app-product-detail-page',
  templateUrl: './product-detail-page.component.html',
  styleUrls: ['./product-detail-page.component.scss'],
})
export class ProductDetailPageComponent implements OnInit {
  product: any;
  showZoomLens = false;
  showZoomResult = false;
  lensPosition = { top: 0, left: 0 };
  zoomPosition = { top: 0, left: 0 };

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private cartService: CartService
  ) {}

  relatedProducts;

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const productId = params.get('id');
      if (productId) {
        this.product = this.dataService.getProductById(productId);
      }
    });
    this.relatedProducts = this.dataService.getProducts();
    this.initializeSlider();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  addToCart(product: any) {
    this.cartService.addProductToCart(product);
  }

  // Function to track the mouse movement and position of the zoom lens
  onMouseMove(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();

    // Get the mouse coordinates relative to the image
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    // Lens size and zoom factor
    const lensSize = 150; // Adjust the size of the zoom lens
    const zoomFactor = 2; // Adjust the zoom factor

    // Position of the zoom lens (clamped within the image bounds)
    this.lensPosition = {
      top: Math.max(0, Math.min(y - lensSize / 2, rect.height - lensSize)),
      left: Math.max(0, Math.min(x - lensSize / 2, rect.width - lensSize)),
    };

    // Position of the zoomed image
    this.zoomPosition = {
      top: this.lensPosition.top * zoomFactor,
      left: this.lensPosition.left * zoomFactor,
    };

    // Show the zoom lens and zoom result
    this.showZoomLens = true;
    this.showZoomResult = true;
  }

  // Function to hide the zoom lens and zoom result when the mouse leaves
  onMouseLeave() {
    this.showZoomLens = false;
    this.showZoomResult = false;
  }

  initializeSlider() {
    setTimeout(() => {
      $('.slick-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }, 0);
  }
}
